var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"social-icon"},_vm._l((_vm.socialList),function(social,i){return _c('li',{key:i},[_c('a',{attrs:{"href":social.url,"target":"_blank"}},[_c('i',{staticClass:"fab",class:social.icon})])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }